import { render } from "./TypeList.vue?vue&type=template&id=0da7afd5&ts=true"
import script from "./TypeList.vue?vue&type=script&lang=ts"
export * from "./TypeList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__